
// --- Header size oberserver ---

const primaryHeader = document.querySelector('.c-header__primary');
const secondaryHeader = document.querySelector('.c-header__secondary');

const observer = new ResizeObserver(entries => {
  for (const { target } of entries) {
    const rootFontSize = Number.parseInt(window.getComputedStyle(document.documentElement).fontSize, 10);
    const propertyName = target === primaryHeader ? '--header-height' : '--header-height-secondary';

    // This property is used in CSS for the header foldout height calculation
    document.documentElement.style.setProperty(propertyName, `${target.offsetHeight / rootFontSize}rem`);
  }
});
observer.observe(primaryHeader);
observer.observe(secondaryHeader);

// --- Mobile foldout trigger ---

const trigger = document.querySelector('.c-header__mobile-trigger');

trigger.addEventListener('click', event => {
  const control = document.getElementById(event.target.getAttribute('aria-controls'));

  if (control) {
    const expanded = event.target.getAttribute('aria-expanded') === 'true';
    event.target.setAttribute('aria-expanded', !expanded);
    control.setAttribute('aria-hidden', expanded);
  }
});